import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Divider, Typography } from '@mui/material';
import OrderEditViewStore from '@components/order/stores/OrderEditViewStore';
import OrderDeliveryInfo from './OrderDeliveryInfo';
import OrderPriceInfo from './OrderPriceInfo';

interface OrderInfoProps {
    orderEditViewStore: OrderEditViewStore;
}

const OrderInfo: React.FC<OrderInfoProps> = observer(({ orderEditViewStore }) => {
    return (
        <Box width={"100%"} mt={2}>
            <OrderDeliveryInfo orderEditViewStore={orderEditViewStore} />
            {/* <Divider/>
            <OrderPriceInfo orderEditViewStore={orderEditViewStore} /> */}
        </Box>
    )
})
export default OrderInfo;